import { Link } from 'react-router-dom';

import { getMessage } from 'common/helpers/miscHelper';

const CreateAccount = (props) => {
  const { settings } = props;
  return (
    <div className="c7-account-login--new">
      <h4>Create an account</h4>
      <p>{getMessage('Login Create Account', settings)}</p>
      <p>
        <Link to="/profile/create-account" className="c7-button">
          Create Account
        </Link>
      </p>
    </div>
  );
};

export default CreateAccount;
